export const getErrorMessage = (
  error,
  fallback = 'Ops! Houve um erro, tente novamente mais tarde.'
) => {
  if (!error) return fallback;

  if (typeof error === 'string') {
    return error.trim() !== '' ? error : fallback;
  }

  const data = error?.response?.data;
  if (data) {
    if (data.errors) {
      if (typeof data.errors === 'string' && data.errors.trim() !== '') {
        return data.errors;
      }

      if (typeof data.errors === 'object') {
        if (Array.isArray(data.errors) && data.errors.length > 0) {
          const first = data.errors[0];
          if (typeof first === 'string' && first.trim() !== '') return first;
        }

        const values = Object.values(data.errors);
        const found = values.find((val) => {
          if (typeof val === 'string' && val.trim() !== '') {
            return true;
          }
          if (
            Array.isArray(val) &&
            val.length > 0 &&
            typeof val[0] === 'string' &&
            val[0].trim() !== ''
          ) {
            return true;
          }
          return false;
        });

        if (found) {
          if (typeof found === 'string') return found;
          if (Array.isArray(found)) return found[0];
        }
      }
    }

    if (typeof data.message === 'string' && data.message.trim() !== '') {
      return data.message;
    }

    if (typeof data.error === 'string' && data.error.trim() !== '') {
      return data.error;
    }
  }

  if (
    typeof error.message === 'string' &&
    error.message.trim() !== '' &&
    !error.message.toLowerCase().includes('network error')
  ) {
    return error.message;
  }

  return fallback;
};

export default getErrorMessage;
